
// Configurable via .env
export let BASE_URL = process.env.REACT_APP_BASE_URL || "https://backend.rezmaze.com/api";
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY || "6LedNs8pAAAAAGRuNp84IbDOogE0rXOu6ts23TLp";
export const STORAGE_URL = process.env.REACT_APP_STORAGE_URL || "https://backend.rezmaze.com/storage/app/public/";
export const Resume_File_Path = process.env.REACT_APP_RESUME_FILE_PATH || "https://backend.rezmaze.com/public/resume-viewer";
// PayPal Configuration
// For testing: Use Sandbox Client ID (works from any country, no real account needed)
// For production: Use Live Client ID
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID || "AQSRigNRvdBQ-b-evXDHOSd7fM5s3h2ajNlwDFHVxyZ0ezJgF7IrzBXqaglxQqnRfzZxprKPmp5uGuSR";
export const PAYPAL_ENVIRONMENT = process.env.REACT_APP_PAYPAL_ENVIRONMENT || "sandbox"; // "sandbox" or "production"

export const IS_MOBILE_VERSION = true;

export default BASE_URL;